module.exports = __webpack_public_path__ + "img/badge-ak.1d8e3224.svg";